// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"fd8d7a1d","925":"d35c8645"}[chunkId] + ".chunk.css";
};